import { FileList, Filters, ListHeader, ListPageLayout, StaticFiltersLayout } from 'framework/list';
import { DATE_FORMAT, useDateService } from 'framework/utils';
import RolesAuditManual from './manual';
import useAuditService from 'domain/audit/shared/auditService';
import AuditDateFilter from '../filter/AuditDateFilter';

const RoleAssignmentsList = () => {
  const { getRoleAssignmentsReport } = useAuditService();
  const { getToday } = useDateService();

  const filters = (
    <Filters>
      <StaticFiltersLayout actionButtonName="Download">
        <AuditDateFilter source="dateTime" />
      </StaticFiltersLayout>
    </Filters>
  );

  return (
    <FileList
      getDataMethod={getRoleAssignmentsReport}
      defaultFilters={{
        dateTime: {
          eq: getToday().format(DATE_FORMAT.API),
        },
      }}
    >
      <ListPageLayout
        showTotal={false}
        header={<ListHeader label="Roles Assignments" icon="fa-black-tie" />}
        filter={filters}
      >
        <RolesAuditManual />
      </ListPageLayout>
    </FileList>
  );
};

export default RoleAssignmentsList;
